import { BASE_API_PATH } from "src/utils/constants";

export const ModulePermissionEndpoints = {
    Module: {
        GetAll: `${BASE_API_PATH}/Module/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/Module/GetAllWithFilter`,
        GetById: (id) => `${BASE_API_PATH}/Module/GetById/${id}`,
    },
    ModulePermission: {
        GetLoggedInUserModulePermissions: (moduleId) => `${BASE_API_PATH}/ModulePermission/GetLoggedInUserModulePermissions?ModuleId=${moduleId}`,
        GetAll: `${BASE_API_PATH}/ModulePermission/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/ModulePermission/GetAllWithFilter`,
        GetById: (id) => `${BASE_API_PATH}/ModulePermission/GetById/${id}`,
    },
    Page: {
        Create: `${BASE_API_PATH}/Page/Create`,
        GetAll: `${BASE_API_PATH}/Page/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/Page/GetAllWithFilter`,
        GetById: (id) => `${BASE_API_PATH}/Page/GetById/${id}`,
        Update: (id) => `${BASE_API_PATH}/Page/Update/${id}`,
        Delete: (id) => `${BASE_API_PATH}/Page/Delete/${id}`,
    },
    PageGuideline: {
        Create: `${BASE_API_PATH}/PageGuideline/Create`,
        GetAll: `${BASE_API_PATH}/PageGuideline/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/PageGuideline/GetAllWithFilter`,
        GetWithFilterUnauth: `${BASE_API_PATH}/PageGuideline/GetWithFilterUnauth`,
        GetById: (id) => `${BASE_API_PATH}/PageGuideline/GetById/${id}`,
        Update: (id) => `${BASE_API_PATH}/PageGuideline/Update/${id}`,
        Delete: (id) => `${BASE_API_PATH}/PageGuideline/Delete/${id}`,
    },
    Permission: {
        GetAll: `${BASE_API_PATH}/Permission/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/Permission/GetAllWithFilter`,
        GetById: (id) => `${BASE_API_PATH}/Permission/GetById/${id}`,
    },
    RoleModulePermission: {
        Create: `${BASE_API_PATH}/RoleModulePermission/Create`,
        GetAll: `${BASE_API_PATH}/RoleModulePermission/GetAll`,
        GetAllWithFilter: `${BASE_API_PATH}/RoleModulePermission/GetAllWithFilter`,
        GetById: (id) => `${BASE_API_PATH}/RoleModulePermission/GetById/${id}`,
        Update: (id) => `${BASE_API_PATH}/RoleModulePermission/Update/${id}`,
        Delete: (id) => `${BASE_API_PATH}/RoleModulePermission/Delete/${id}`,
    },
};

